<template>
	<transition name="fade" @enter="beginCycleCountdown">
		<div class="countdown-overlay" :class="{ fading: lastWord }">
			<BouncingText class="cycle-countdown" :text="cycleText" />
		</div>
	</transition>
</template>

<script>
import BouncingText from '@/components/abstract/BouncingText';
import { mapState, mapActions } from 'vuex';

export default {
	name: 'Interface',
	components: {
		BouncingText,
	},
	data() {
		return {
			wordIndex: 0,
		};
	},
	computed: {
		...mapState({
			gameOver: state => state.gameOver,
			ui: state => state.config.ui.cycle_countdown,
		}),
		wordsArray() {
			return this.gameOver ? this.ui.game_over_text : this.ui.normal_text;
		},
		cycleText() {
			return this.wordsArray[this.wordIndex].text;
		},
		lastWord() {
			return this.wordIndex === this.wordsArray.length - 1;
		},
	},
	methods: {
		...mapActions(["startCycle"]),
		beginCycleCountdown() {
			this.$store.commit("addTimer", {
				duration: 1000,
				ref: "cycleCountdown",
				repeat: 3,
				action: (payload) => {
					if (payload.timer.repeats > 1) {
						this.wordIndex += 1;
						if (this.lastWord && !this.gameOver) {
							this.startCycle();
						}
					} else if (!this.gameOver) {
						this.wordIndex = 0;
						this.$store.commit("deactivateCycleCountdown");
					}
				},
			});
		},
	},
};
</script>

<style lang="scss" scoped>
	.countdown-overlay {
		@include cover;
		z-index: 19;
		background-color: rgba(0, 0, 0, .25);
		pointer-events: none;
		transition: background-color $ui-transition-duration;

		&.fading {
			background-color: rgba(0, 0, 0, 0);
		}
	}

	.cycle-countdown {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
	}
</style>



// WEBPACK FOOTER //
// src/components/board/CycleCountdown.vue